//@ts-check

import {Text} from '@/components-v2/atoms/Text/Text'
import {Icon} from '@pepsico-ds/ui'

/**
 * @typedef {Object} ProductReviewSectionProps
 * @property {string} [title] Optional section title.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [icon] Optional icon rendered before title.
 * @property {import('react').ReactNode} [children] Section content.
 */

/**
 * Product review section container with optional header.
 * @param {ProductReviewSectionProps} props
 */
export const ProductReviewSection = ({title, icon, children}) => {
  return (
    <div className="relative overflow-hidden rounded-[var(--border-radius-container-large)] bg-[var(--color-background-layer-01)] p-6">
      {(title || icon) && (
        <div className="flex items-center gap-2 py-3">
          {icon ? <Icon icon={icon} /> : null}
          {title ? (
            <Text variant="bold" className="!text-[22px]">
              {title}
            </Text>
          ) : null}
        </div>
      )}
      <div className="divide-y divide-[var(--secondary-800)]">{children}</div>
    </div>
  )
}
